import { render, staticRenderFns } from "./paginaRaiz.vue?vue&type=template&id=6e81706a"
import script from "./paginaRaiz.vue?vue&type=script&lang=js"
export * from "./paginaRaiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports